<template>
    <b-modal v-model="isVisible" centered hide-footer hide-header-close @show="load">
        <base-select v-model="selectPet.value" @change="changePetHistory" :loading="selectPet.loading" :placeholder="$t('clinic-history.select-pet')" label="name" valueProp="id" searchable filtered :options="selectPet.data" clearable />
        <span class="back-history" v-if="selectPet.value" @click="backHistory">{{$t('clinic-history.back-history')}}</span>
    </b-modal>
</template>

<script>
import PetRepository from '@/repositories/PetRepository'
import { BModal } from 'bootstrap-vue'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

export default {
    data () {
        return {
            selectPet: {
                data: [],
                value: null,
                loading: false
            }
        }
    },
    mixins: [i18nMixin(I18N_FILE)],
    components: {
        BModal
    },
    props: {
        value: Boolean,
        path: String
    },
    created () {
    },
    methods: {
        load () {
            if (this.selectPet.data.length === 0) {
                this.selectPet.loading = true
                PetRepository.getPatientPets().then(result => {
                    if (result.data.data.length === 0) {
                        this.$emit('hidePetSelectors')
                    } else {
                        this.selectPet.data = result.data.data.map(item => { return {name: `${item.name} (${this.$i18nHelpers.normalize(item.animalType)})`, id: item.idAnimal} })
                        this.selectPet.loading = false
                        this.selectPet.value = this.$route.query.petId ? this.$route.query.petId : null
                    }
                })
            } else {
                this.selectPet.value = this.$route.query.petId ? this.$route.query.petId : null
            }
        },
        changePetHistory () {
            this.$router.push(`${this.path}${this.selectPet.value ? `?petId=${this.selectPet.value}` : ''}`)
        },
        backHistory () {
            this.$router.push(`${this.path}`)
        }
    },
    computed: {
		isVisible: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
	}
}
</script>

<style lang="scss" scoped>
.back-history{
    float: right;
    cursor: pointer;
    margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ChangePetModal.vue